// removed by extract-text-webpack-plugin
module.exports = {"carriers-grid-section":"src-components----CarriersGridSection-module---carriers-grid-section---265dB","logos-table":"src-components----CarriersGridSection-module---logos-table---285zo","logo-cell":"src-components----CarriersGridSection-module---logo-cell---34seA","disclaimer-container":"src-components----CarriersGridSection-module---disclaimer-container---2-oq_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CarriersGridSection.module.scss
// module id = 653
// module chunks = 222764574844450